
import vClickOutside from 'v-click-outside';
import { mapGetters, mapMutations } from 'vuex';
import EcomMenuBadges from '~/components/badges/EcomMenuBadges.vue';
export default {
    name: 'CatalogMenu',
    components: { EcomMenuBadges },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    props: {
        isCatalog: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            getStateCatalog: 'getStateCatalog',
            categoryMenu: 'getMenu',
        }),
        windowWidth() {
            if (process.client) {
                return window.innerWidth;
            } else {
                return 1440;
            }
        },
    },
    methods: {
        ...mapMutations(['setMainMenu']),
        ...mapMutations({
            setStateCatalog: 'setStateCatalog',
        }),
    },
    async fetch() {
        let menu = await this.$axios.$get('general/menu_tree');
        if (menu.length) {
            this.setMainMenu(menu);
        }
    },
};
